/**
 * Message-part registry.
 *
 * Reasoning and visible tool calls are activity: `MessageItem` folds each run
 * of them into one `ActivityFeed`. Every other part renders through
 * {@link renderPart}, which returns `null` for parts with no inline UI so they
 * never break a run.
 */ import { UiDataPartType } from "@juristic/types/stream/ai/data_events";
import { ToolHookEventType } from "@juristic/types/stream/ai/tool_hooks";
import { HIDDEN_TOOL_NAMES } from "@juristic/types/stream/ai/tool_metadata";
import { getToolName, isToolUIPart } from "ai";
import React from "react";
import { isCompactionDivider } from "../utils/compaction";
import { QUESTION_TOOL_NAMES } from "../utils/tool-utils";
import { isWordExecWrite } from "../utils/waitingIndicator";
import { CompactionDivider } from "./CompactionDivider";
import { ErrorPart } from "./ErrorPart";
import { TextPart } from "./TextPart";
import { ToolHookPart } from "./ToolHookPart";
const HIDDEN_TOOL_NAMES_SET = new Set([
    ...HIDDEN_TOOL_NAMES,
    ...QUESTION_TOOL_NAMES
]);
export function isFeedPart(part) {
    if (part.type === "reasoning") return Boolean(part.text);
    return isToolUIPart(part) && !HIDDEN_TOOL_NAMES_SET.has(getToolName(part));
}
export function renderPart(part, partIndex, ctx) {
    switch(part.type){
        case "text":
            return part.text ? /*#__PURE__*/ React.createElement(TextPart, {
                part: part,
                partIndex: partIndex,
                ctx: ctx
            }) : null;
        case UiDataPartType.Error:
            return /*#__PURE__*/ React.createElement(ErrorPart, {
                part: part,
                partIndex: partIndex,
                ctx: ctx
            });
        case UiDataPartType.ToolHook:
            return part.data.type === ToolHookEventType.ConfirmationRequest || part.data.type === ToolHookEventType.ChoiceRequest || isWordExecWrite(part.data) ? /*#__PURE__*/ React.createElement(ToolHookPart, {
                part: part,
                partIndex: partIndex,
                ctx: ctx
            }) : null;
        case UiDataPartType.Workflow:
            return isCompactionDivider(ctx.message.parts, partIndex) ? /*#__PURE__*/ React.createElement(CompactionDivider, null) : null;
        default:
            return null;
    }
}
